module.exports = __webpack_public_path__ + "static/fun-time/audio/karta1//1_hello.mp3";